<template>
    <CasesMaterial
        class="my-2 cases-material-full-width"
        :material="module.html"
        :newCase="true"
    />
</template>

<script>
    import CasesMaterial  from '~/components/case/Text.vue';

    export default {
        props: ['module'],

        components: {
            CasesMaterial
        }
    }
</script>

<style>

</style>
